var _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.632 5.015a2.543 2.543 0 0 1-4.762 0H.886A.888.888 0 0 1 0 4.13c0-.502.393-.895.885-.895H11.86c.36-.961 1.3-1.66 2.391-1.66 1.092 0 2.031.699 2.392 1.66h3.505c.459 0 .852.393.852.895 0 .492-.393.885-.852.885h-3.516Zm-3.615-.896c0 .688.546 1.234 1.234 1.234.7 0 1.234-.546 1.234-1.234 0-.698-.535-1.234-1.234-1.234-.688 0-1.234.536-1.234 1.234ZM6.87 13.031c1.092 0 2.02-.7 2.38-1.671h10.866a.88.88 0 0 0 .885-.885.88.88 0 0 0-.885-.884H9.25a2.543 2.543 0 0 0-2.381-1.65c-1.092 0-2.02.689-2.392 1.65H.852c-.459 0-.852.393-.852.884 0 .492.393.885.852.885h3.625c.36.972 1.3 1.67 2.392 1.67Zm-1.234-2.556c0 .688.546 1.234 1.234 1.234.699 0 1.234-.546 1.234-1.234a1.21 1.21 0 0 0-1.234-1.223c-.688 0-1.234.535-1.234 1.223Z",
    fill: "#222"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 4,
    r: 2,
    fill: "#222"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 10.75,
    r: 1.75,
    fill: "#222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.562ed70e2bc6a58f2f91a3b432654c17.svg";
export { ForwardRef as ReactComponent };